import { dispatcher, ingenuity } from "@quest/base-core";
import { Reel } from "@quest/murka-games-behavior-panther";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class ReelGame extends Reel {
  /**
   * Method overrided to play symbol animation
   */
  playAnimByPos(pos: any, symReel: any, opts: any) {
    const parent: any = this.parent;
    const sym = parent.getSymbolByPos(this.reelId, pos);
    sym.getStatic().visible = false;
    const icon = sym.getAnimation();
    this.stackOffset = (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin();
    if (!icon) {
      return;
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
    }
    const symPosition = [this.reelId, pos];
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      const offsetForStickyFind: boolean = this.findStickySymbolOffSet(symPosition);
      !offsetForStickyFind && symReel.addChild(icon);
    }
    symReel.addChild(icon);
    icon.visible = !sym.forceHide;
    this.hiddenIcons.push(icon);
    if (!this.checkSymbolInArray(icon)) {
      this.AllIcons.push(icon);
    }
    const staticAnim = icon.json.animations ? icon.json.animations.static : "static";
    const winAnim = icon.json.animations ? icon.json.animations.anim : "animation";
    icon.playAnim(staticAnim, false, 0);
    setTimeout(() => {
      icon.playAnim(winAnim);
    }, 10);
  }

  /**
   * Find sticky symbol offset
   */
  private findStickySymbolOffSet(winOffSet: number[]): boolean {
    let flag: boolean = false;
    const stickyGrid: number[][] = (ingenuity.parserModel as GameParserModel).getStickyWildData().wildPos;
    if (stickyGrid) {
      const rowIndex: number = winOffSet[0];
      for (let i: number = 0; i < stickyGrid.length; i++) {
        if (stickyGrid[i][1] == winOffSet[1] && stickyGrid[i][0] == rowIndex) {
          flag = true;
          dispatcher.fireEvent(eventDispatchers.PLAY_STICKY_WIN_ANIM, i);
          break;
        }
      }
      return flag;
    }
  }
}
